document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('.recently-viewed-search-block');
  const lists = document.querySelectorAll('.recently-viewed-search-list');
  if (!blocks.length || !lists.length) return;

  const recentRaw = localStorage.getItem('recently-viewed');
  const recentIds = recentRaw ? JSON.parse(recentRaw) : [];
  if (!recentIds.length) return;

  let query = '';
  let count = 0;
  recentIds.forEach(handle => {
    if (count >= 4) return;
    query += 'handle:' + handle + ' OR ';
    count++;
  });
  if (!query) return;

  const url = (window.theme?.routes?.search_url || '/search') +
    '?view=recently-viewed-horizontal&type=product&q=' + encodeURIComponent(query);

  fetch(url)
    .then(r => r.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const fetched = Array.from(html.querySelectorAll('.search__items-item'));
      if (!fetched.length) return;

      const ordered = [];
      recentIds.forEach(handle => {
        const match = fetched.find(el => el.dataset.handle === handle);
        if (match) ordered.push(match);
      });
      if (!ordered.length) return;

      // Populate every rendered instance (tablet nav search + mobile overlay)
      lists.forEach((list, index) => {
        ordered.forEach(el => {
          list.appendChild(index === 0 ? el : el.cloneNode(true));
        });
      });
      blocks.forEach(block => { block.style.display = ''; });
    })
    .catch(e => console.error('Recently viewed (search) error:', e));
});